import { useAirline } from "../context/AirlineContext";
import { TeamFlatGrid } from "../shared/AirlineSlideRenderers";

const SlideCathayTeam = () => {
  const { airline } = useAirline();
  return <TeamFlatGrid airline={airline} brand={airline.brandColor || "#005D63"} />;
};

export default SlideCathayTeam;
